var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.53436 0H13.8562V16H2.53436V0Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.125 0H2.53438V16H-3.125V0ZM13.8563 0H19.5156V16H13.8563V0ZM4.22813 7.73125L3.79063 7.88125L5.83438 9.67813C5.99063 10.1406 5.78125 10.275 5.64688 10.5188L7.86563 10.2375L7.80937 12.4719L8.27188 12.4563L8.16875 10.2406L10.3938 10.5031C10.2563 10.2125 10.1344 10.0594 10.2594 9.59688L12.3031 7.89375L11.9469 7.76562C11.6531 7.5375 12.0719 6.67812 12.1344 6.13438C12.1344 6.13438 10.9438 6.54375 10.8656 6.32812L10.5562 5.75L9.475 6.9375C9.35625 6.96875 9.30625 6.91875 9.27812 6.81875L9.77812 4.32812L8.98438 4.775C8.91875 4.80312 8.85312 4.775 8.80937 4.7L8.04375 3.16875L7.25625 4.75938C7.19688 4.81563 7.1375 4.82188 7.0875 4.78438L6.33125 4.35938L6.78438 6.83437C6.75 6.92812 6.6625 6.95937 6.5625 6.90625L5.52188 5.725C5.3875 5.94375 5.29375 6.3 5.11563 6.38125C4.9375 6.45312 4.33437 6.22813 3.93125 6.14062C4.06875 6.6375 4.5 7.4625 4.22813 7.73438V7.73125Z",
    fill: "#D52B1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/ca.c11c944a51159a7cf22fdcb386e19d43.svg";
export { ForwardRef as ReactComponent };